import { Component, OnInit, Input } from '@angular/core';
import { ProjectManagementService } from 'app/services/project-management.service';
import { DataService } from 'app/services/data.service';
import { FrontEndService } from 'app/services/front-end.service';
import { StateService } from '@uirouter/angular';
import { Transition } from '@uirouter/angular';
import "styles/app.scss";

import { LogService } from "app/services/log.service";

@Component({
    selector: 'app-single-post',
    templateUrl: './single-post.component.html',
    styleUrls: ['./single-post.component.scss']
})
export class SinglePostComponent implements OnInit {

    @Input() download_file;

    wall_post_list;
    project_id: number;
    post_id: number;

    constructor(
        private project_management_service: ProjectManagementService,
        public dataService: DataService,
        public front_end_service: FrontEndService,
        private stateService: StateService,
        private transition: Transition,
        private logService: LogService
    ) { }

    ngOnInit() {
        this.wall_post_list = [];

        this.project_id = +this.transition.params().project_id;
        this.post_id = +this.transition.params().post_id;

        this.dataService.selected_project = this.project_id;

        if(this.project_id === undefined || this.project_id === null) {
            this.stateService.go('notFound');
        } else if(this.post_id === undefined || this.post_id === null) {
            this.stateService.go('project', {project_id: this.project_id});
        } else {
            this.wall_get(this.project_id, 0, 0);
        }
    }

    wall_get(
        project_id,
        limit,
        offset,
        continue_fetch = false,
    ) {

        this.project_management_service.wall_get(project_id, limit, offset, (resp) => {
            if (resp.status === true) {
                this.logService.printLog("Got Project Wall controller callback");
                if(resp.message === "please_use_correct_wall_post_id") {
                    this.stateService.go('notFound');
                } else {
                    this.wall_post_list.push(resp.data);
                }
            } else {
                this.logService.printLog("Failed Project Wall controller callback");
            }
        }, this.post_id, true);
    }
}
